<template>
  <div class="Container">
    <div class="Title">
      {{ title }}
    </div>

    <vv-button-reverse @click="$emit('click')">{{ button }}</vv-button-reverse>
  </div>
</template>

<script>
import { VvButtonReverse } from '@/components/common'

export default {
  name: 'DesktopMasterclassSwitchButton',
  components: { VvButtonReverse },
  props: {
    type: {
      type: String,
      default: 'learn',
      validator: val => ['learn', 'taste'].includes(val)
    }
  },
  computed: {
    title() {
      switch (this.type) {
        case 'taste':
          return this.$t('masterclass.switch.to_lesson.title')

        case 'learn':
        default:
          return this.$t('masterclass.switch.to_tasting.title')
      }
    },
    button() {
      switch (this.type) {
        case 'taste':
          return this.$t('masterclass.switch.to_lesson.button')

        case 'learn':
        default:
          return this.$t('masterclass.switch.to_tasting.button')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.Container {
  padding: 25px 35px;
  background-color: $primary;
  border-radius: 4px;
  margin-top: 35px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .Title {
    color: white;
    font-weight: 600;
    font-size: 24px;
  }
}
</style>
